































import { defineComponent, ref, onMounted } from '@nuxtjs/composition-api';
import { useIntersectionObserver } from '@vueuse/core';
import type { PropType } from '@nuxtjs/composition-api';
import { LinkType } from '~/types/components/Link/LinkType';
import { useIntegrations, useRecommendationIntersection } from '~/composables';
import { BloomreachProduct } from '~/types/product/BloomreachProduct';
import ProductAnchorTitle from '~/components/atoms/Product/ProductAnchorTitle/ProductAnchorTitle.vue';
import { EVENT_SOURCE } from '~/constants/googleTagManager';
import ProductSlider from '~/components/organisms/Product/ProductSlider/ProductSlider.vue';
import BloomreachEnvironmentWarning from
  '~/components/organisms/Product/Bloomreach/BloomreachEnvironmentWarning/BloomreachEnvironmentWarning.vue';
import { createOnSaleLink } from '~/helpers/navigation/createNavLinks';
import { BLOOMREACH_TYPE_NAME } from '~/types/localization/localizationHelperTypes';
import type { ProductCardSize } from '~/constants/productCardSize';
import { PRODUCT_CARD_SIZE } from '~/constants/productCardSize';

export default defineComponent({
  name: 'BloomreachSimilarProducts',
  components: {
    BloomreachProduct: () => import(/* webpackChunkName: "BloomreachProduct" */
      '~/components/molecules/Product/Bloomreach/BloomreachProduct/BloomreachProduct.vue'),
    ProductAnchorTitle,
    BloomreachEnvironmentWarning,
    ProductSlider,
  },
  props: {
    sourceSku: {
      type: String,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
    size: {
      type: String as PropType<ProductCardSize>,
      default: PRODUCT_CARD_SIZE.MEDIUM,
      validator: (value: ProductCardSize) => {
        return Object.values(PRODUCT_CARD_SIZE).includes(value);
      },
    },
    hasArrows: {
      type: Boolean,
      default: true,
    },
    hasMargin: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const { $bloomreach } = useIntegrations();
    const bloomreachProducts = ref<BloomreachProduct[] | null>(null);

    const bloomreachSimilarProducts = ref<HTMLElement | null>(null);

    const { onIntersectOnce } = useRecommendationIntersection({
      suggestedProducts: bloomreachProducts,
      recommendationType: BLOOMREACH_TYPE_NAME.SIMILAR_PRODUCTS,
    });
    useIntersectionObserver(bloomreachSimilarProducts, onIntersectOnce);

    onMounted(async () => {
      bloomreachProducts.value = await $bloomreach.getSimilarProducts(props.sourceSku);
    });

    const onSaleLink = createOnSaleLink();

    return {
      bloomreachProducts,
      bloomreachSimilarProducts,
      LinkType,
      EVENT_SOURCE,
      PRODUCT_CARD_SIZE,
      onSaleLink,

    };
  },
});
